module.exports = __webpack_public_path__ + "static/media/checked.ed63539c.svg";